
import React from 'react';

   // const ApiURl = "http://localhost/new_event%20-%20tradition/backend/";

   const ApiURl = "https://tradition.algo2bots.com/backend";










    export default   ApiURl ;